<footer
  class="w-full bg-transparent border-t border-slate-200 dark:border-slate-800 transition-colors duration-300"
>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
    <div class="flex flex-col md:flex-row justify-between items-center gap-6">
      <div class="flex flex-col items-center md:items-start">
        <a
          routerLink="/"
          class="text-2xl font-bold bg-clip-text text-transparent bg-linear-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400"
        >
          MyPlace
        </a>
        <p
          class="mt-2 text-sm text-slate-500 dark:text-slate-400 text-center md:text-left"
        >
          {{ "FOOTER.TAGLINE" | translate }}
        </p>
      </div>

      <div class="flex items-center gap-6">
        <a
          routerLink="/terms"
          class="text-sm text-slate-600 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >{{ "FOOTER.TERMS" | translate }}</a
        >
        <a
          routerLink="/privacy"
          class="text-sm text-slate-600 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >{{ "FOOTER.PRIVACY" | translate }}</a
        >
        <a
          routerLink="/contact"
          class="text-sm text-slate-600 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >{{ "FOOTER.CONTACT" | translate }}</a
        >
      </div>
    </div>
    <div
      class="mt-8 pt-8 border-t border-slate-200 dark:border-slate-800 flex flex-col md:flex-row justify-between items-center"
    >
      <p class="text-sm text-slate-500 dark:text-slate-400">
        &copy; {{ currentYear }} MyPlace. {{ "FOOTER.COPYRIGHT" | translate }}
      </p>
      <div
        class="mt-4 md:mt-0 flex items-center text-xs text-slate-400 dark:text-slate-500"
      >
        {{ "FOOTER.MADE_WITH" | translate }}
        <span class="icon-[mdi--heart] text-red-500 mx-1 text-base"></span>
        {{ "FOOTER.MADE_WITH_END" | translate }}
      </div>
    </div>
  </div>
</footer>
